/* Contact Form - Custom Element for Validation */

class ContactForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    if (this.form) {
      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }
  }

  onSubmit(event) {
    const submitButton = this.form.querySelector('[type="submit"]');
    const spinner = submitButton?.querySelector('.loading-overlay__spinner');

    // Validate required fields
    const requiredFields = this.querySelectorAll('[data-required="true"] .field__input');
    let isValid = true;

    requiredFields.forEach(field => {
      const wrapper = field.closest('.field-wrapper');
      const errorMsg = wrapper?.querySelector('.field-wrapper__error-msg');

      if (!field.value.trim()) {
        isValid = false;
        if (errorMsg) {
          errorMsg.classList.remove('hidden');
        }
        field.classList.add('field__input--error');
      } else {
        if (errorMsg) {
          errorMsg.classList.add('hidden');
        }
        field.classList.remove('field__input--error');
      }
    });

    // Email validation
    const emailField = this.form.querySelector('input[type="email"]');
    if (emailField && emailField.value) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(emailField.value)) {
        isValid = false;
        const wrapper = emailField.closest('.field-wrapper');
        const errorMsg = wrapper?.querySelector('.field-wrapper__error-msg');
        if (errorMsg) {
          errorMsg.classList.remove('hidden');
        }
        emailField.classList.add('field__input--error');
      }
    }

    if (!isValid) {
      event.preventDefault();
      return;
    }

    // Show loading state
    if (submitButton) {
      submitButton.setAttribute('disabled', 'disabled');
      submitButton.classList.add('loading');
    }
    if (spinner) {
      spinner.classList.remove('hidden');
    }
  }
}

customElements.define('contact-form', ContactForm);
